import URLHelper from './url-helper';

export default {
  onboarding(args = {}) {
    return URLHelper.build('/onboarding', args);
  },

  onboardingActionItems(args = {}) {
    return URLHelper.build('/onboarding/action_items', args);
  },
};
